/**
 *  风控管理  v4.6 去掉该功能
 * */
import React, { PureComponent } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XInputNum } from '@/components/xqxc_ui';
import { InfoCircleOutlined } from '@ant-design/icons';
import { message, Switch, Tooltip } from 'antd';
import model from '@/reducers/system/riskcontrol/model';
import { setBreadcrumbPaths } from '@/reducers/home/actions';


class Riskcontrol extends PureComponent {

    state = {
        unionpay: false,//开启银联钱包
        upointTime: null,//银联转账时间点
    }

    componentDidMount() {
        const { setBreadcrumbPaths, match, getRiskcontrol } = this.props;
        setBreadcrumbPaths(match); // 自动识别面包屑
        getRiskcontrol({ paramType: 'RISK' });//风控管理初始数据
    }

    componentDidUpdate(prevProps) {
        if (this.props.riskcontrol !== prevProps.riskcontrol) {
            let params = this.props.riskcontrol;

            let data = params.map((v) => {
                switch (v.paramCode) {
                    case 'IS_OPEN_UNION_WALLET'://开启银联钱包
                        this.setState({ unionpay: v.paramValue == '1' ? true : false });
                        return;
                    case 'PAY_HANDLE_SETTLE_ACCOUNT_TIME'://银联转账时间点
                        this.setState({ upointTime: v.paramValue });
                        return;
                }
            });
        }
    }

    //提示
    renderTips = () => {
        return <div className={styles.pois}>
            <Tooltip placement="left" title="光标移开触发保存">
                <InfoCircleOutlined />
            </Tooltip>
        </div>;
    }

    //保存
    _savehandle = (code, value) => {
        let params = {
            paramCode: code,
            paramValue: value
        };
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.updateAdminParamValue', params, 'POST').then(() => {
            message.success('保存成功');
        }).catch((e = {}) => {
            message.error(e.message);
        });
    }

    render() {
        const { unionpay, upointTime } = this.state;

        // 懒猪快送4.6，更换钱包任务 去掉 风控 功能展示。
        if(true){
            return null;
        }

        return (
            <div className={styles.tablehead} >
                <div className={styles.homeLayout}>
                    <div className={styles.riskcontent}>
                        <div className={styles.item}>
                            <h4>设置项</h4>
                            <p>用途</p>
                            <div className={styles.renderTips}>参数值{this.renderTips()}</div>
                        </div>
                        <div className={styles.item}>
                            <h4>开启银联钱包</h4>
                            <p>开启银联钱包，骑士注册和骑士收益支取使用银联对接。</p>
                            <div>
                                <Switch
                                    disabled
                                    checkedChildren="开"
                                    unCheckedChildren="关"
                                    checked={unionpay}
                                    onChange={(val) => {
                                        this.setState({
                                            unionpay: val
                                        }, () => {
                                            this._savehandle('IS_OPEN_UNION_WALLET', val === true ? '1' : '0');
                                        });
                                    }}
                                />
                            </div>
                        </div>

                        <div className={styles.item}>
                            <h4>银联转账时间点</h4>
                            <p>今天的几点开始执行昨天完成的订单转账到懒猪平台电子账户，因为银联要T+1资金才执行。</p>
                            <div>
                                <XInputNum
                                    style={{ width: '100px', marginLeft: '117px' }}
                                    inputStyle={{ width: '93px' }}
                                    placeholder='请输入'
                                    value={upointTime}
                                    min={14}
                                    max={23}
                                    precision={0}
                                    bindThis={this}
                                    bindName='upointTime'
                                    onBlur={(e) => {
                                        if (!e.target.value) this.setState({ upointTime: 1 });
                                        this._savehandle('PAY_HANDLE_SETTLE_ACCOUNT_TIME', !e.target.value ? 1 : e.target.value);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Riskcontrol.propTypes = {
    history: PropTypes.object, // 路由history对象
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息

    riskcontrol: PropTypes.array,
    getRiskcontrol: PropTypes.func,//风控管理初始数据(action)
};

const mapStateToProps = (state) => ({
    riskcontrol: state.riskcontrol.riskcontrol,
});

export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Riskcontrol);
